import React from 'react';
import debounce from 'lodash/debounce';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import s from './NumericField.scss';
const NumericField = ({ label, value, onChange, minValue = 0, maxValue = 100, sliderStep = 1 })=>/*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("label", {
        className: s['label']
    }, label), /*#__PURE__*/ React.createElement("input", {
        className: s['range-slider'],
        value: value,
        type: "range",
        step: sliderStep,
        max: maxValue,
        min: minValue,
        onChange: debounce((ev)=>onChange(ev.target.value), 150, {
            leading: true
        })
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['range-input-wrapper']
    }, /*#__PURE__*/ React.createElement(TextInput, {
        id: "editor-gallery-range-input",
        className: s['range-input'],
        type: 'number',
        value: value.toString(),
        onChange: (ev)=>onChange(ev.target.value),
        min: minValue,
        max: maxValue,
        label: label,
        isLabelHidden: true
    })));
export default NumericField;
